module.exports = __webpack_public_path__ + "static/media/BSW.a4e12f96.png";